var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "form-horizontal" },
    [
      _c(
        "wizard-form-row",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.lifeExpectancy,
                          expression: "tooltips.lifeExpectancy",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [_vm._v("\n        life expectancy\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "form-control input-sm",
              domProps: { value: _vm.formData.lifeExpectancy },
              on: {
                change: function ($event) {
                  return _vm.setFormData({
                    lifeExpectancy: $event.target.value,
                  })
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("- select -")]),
              _vm._v(" "),
              _vm._l(_vm.lifeExpectancyOptions, function (value) {
                return _c(
                  "option",
                  { key: value, domProps: { value: value } },
                  [_vm._v(_vm._s(value))]
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "wizard-form-row",
        {
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your TSP\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.withdrawalAge,
                          expression: "tooltips.withdrawalAge",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [_vm._v("\n        withdrawal age\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass: "form-control input-sm",
              attrs: { disabled: _vm.withdrawalAgeYears.length === 0 },
              domProps: { value: _vm.formData.withdrawalAgeYears },
              on: {
                change: function ($event) {
                  return _vm.setFormData({
                    withdrawalAgeYears: $event.target.value,
                  })
                },
              },
            },
            _vm._l(_vm.withdrawalAgeYears, function (value) {
              return _c("option", { key: value, domProps: { value: value } }, [
                _vm._v(_vm._s(value)),
              ])
            }),
            0
          ),
          _vm._v("\n    year(s)\n    "),
          _c(
            "select",
            {
              staticClass: "form-control input-sm",
              attrs: { disabled: _vm.withdrawalAgeMonths.length === 0 },
              domProps: { value: _vm.formData.withdrawalAgeMonths },
              on: {
                change: function ($event) {
                  return _vm.setFormData({
                    withdrawalAgeMonths: $event.target.value,
                  })
                },
              },
            },
            _vm._l(_vm.withdrawalAgeMonths, function (value) {
              return _c("option", { key: value, domProps: { value: value } }, [
                _vm._v(_vm._s(value)),
              ])
            }),
            0
          ),
          _vm._v("\n    month(s)\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "wizard-form-row",
        {
          attrs: { hasError: _vm.contributionRateHasError },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your TSP\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.contributionRate,
                          expression: "tooltips.contributionRate",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [_vm._v("\n        contribution rate\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-sm" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "number",
                min: _vm.config.contributionRateMin,
                max: _vm.config.contributionRateMax,
              },
              domProps: { value: _vm.formData.contributionRate },
              on: {
                input: function ($event) {
                  _vm.setFormData({
                    contributionRate: Number(
                      Number($event.target.value).toFixed(0)
                    ),
                  })
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-addon" }, [_vm._v("%")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "wizard-form-row",
        {
          attrs: { hasError: _vm.growthRateHasError },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your TSP\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.rateOfReturn,
                          expression: "tooltips.rateOfReturn",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [_vm._v("\n        rate of return\n      ")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-sm" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "number",
                min: _vm.config.growthRateMin,
                max: _vm.config.growthRateMax,
              },
              domProps: { value: _vm.formData.growthRateDisplay },
              on: {
                keyup: function ($event) {
                  return _vm.formatRate(
                    $event,
                    "growthRate",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-addon" }, [_vm._v("%")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "wizard-form-row",
        {
          attrs: { hasError: _vm.withdrawalGrowthRateHasError },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your TSP\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.withdrawRate,
                          expression: "tooltips.withdrawRate",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [
                      _vm._v(
                        "\n        rate of return after you begin to withdrawal\n      "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-sm" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "number",
                min: _vm.config.growthRateMin,
                max: _vm.config.growthRateMax,
              },
              domProps: { value: _vm.formData.withdrawalGrowthRateDisplay },
              on: {
                keyup: function ($event) {
                  return _vm.formatRate(
                    $event,
                    "withdrawalGrowthRate",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-addon" }, [_vm._v("%")]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showFor("ac2rc", "rc2ac", "rc2rc")
        ? _c(
            "wizard-form-row",
            {
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _vm._v(
                          "\n      Set your non-regular retirement pay age\n    "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1730216596
              ),
            },
            [
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control input-sm",
                  attrs: { disabled: _vm.retirementAgeYears.length === 0 },
                  domProps: { value: _vm.formData.retirementAgeYears },
                  on: {
                    change: function ($event) {
                      return _vm.setFormData({
                        retirementAgeYears: $event.target.value,
                      })
                    },
                  },
                },
                _vm._l(_vm.retirementAgeYears, function (value) {
                  return _c(
                    "option",
                    { key: value, domProps: { value: value } },
                    [_vm._v(_vm._s(value))]
                  )
                }),
                0
              ),
              _vm._v("\n    year(s)\n    "),
              _c(
                "select",
                {
                  staticClass: "form-control input-sm",
                  attrs: {
                    disabled:
                      typeof _vm.retirementAgeMonths === "undefined" ||
                      _vm.retirementAgeMonths.length === 0,
                  },
                  domProps: { value: _vm.formData.retirementAgeMonths },
                  on: {
                    change: function ($event) {
                      return _vm.setFormData({
                        retirementAgeMonths: $event.target.value,
                      })
                    },
                  },
                },
                _vm._l(_vm.retirementAgeMonths, function (value) {
                  return _c(
                    "option",
                    { key: value, domProps: { value: value } },
                    [_vm._v(_vm._s(value))]
                  )
                }),
                0
              ),
              _vm._v("\n    month(s)\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "wizard-form-row",
        {
          attrs: { hasError: _vm.tspServiceMemberContributionHasError },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _vm._v("\n      Set your TSP\n      "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "popover",
                          rawName: "v-popover.hover",
                          value: _vm.tooltips.balanceServiceMember,
                          expression: "tooltips.balanceServiceMember",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "text-underline",
                    },
                    [_vm._v("\n        account balance\n      ")]
                  ),
                  _vm._v("\n      from Service Member contributions\n    "),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "input-group input-group-sm" }, [
            _c("div", { staticClass: "input-group-addon" }, [_vm._v("$")]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "number",
                min: _vm.config.tspServiceMemberContributionMin,
                max: _vm.config.tspServiceMemberContributionMax,
              },
              domProps: { value: _vm.formData.tspServiceMemberContribution },
              on: {
                input: function ($event) {
                  _vm.setFormData({
                    tspServiceMemberContribution: Number(
                      Number($event.target.value).toFixed(0)
                    ),
                  })
                },
              },
            }),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }